<template>
  <section>
    <PageTitle title="POS Dashboard" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/pos_dashboard',title:'POS Dashboard'}]"/>
    <div class="wrapper wrapper-content">
      <div class="row">
        <div class="col-lg-1 float-right width-18">
          <div class="ibox float-e-margins">
          <div class="ibox-title">
            <div class="ibox-tools center">
              <a class="dropdown-toggle" data-toggle="dropdown" href="#">
                {{selectedOption.label}}
                &nbsp;<i class="fa fa-clock-o"></i>
              </a>
              <ul class="dropdown-menu dropdown-user">
                <li v-for="option in dateOptions" :key="option.label">
                  <a href="javascript:void(0)" @click="selectDate(option.label)">{{ option.label }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        </div>
        <div class="col-lg-1 float-left center">
          <h2>Dashboard</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <div class="widget style1">
            <div class="row">
              <div class="col-md-4 text-center">
                <i class="fa fa-trophy fa-5x"></i>
              </div>
              <div class="col-md-8 text-right">
                <span> Today Sale </span>
                <h2 class="font-bold" style="font-size: 24px"><i class="fa fa-money"></i> {{ totalNetSale }}</h2>
              </div>
            </div>
          </div>
        </div>
          <PosSaleCard :title="'Item Wise Sale'" @cardClick="downloadSale('item_wise_sale')" :icon="'fa fa-shopping-cart fa-5x'" :color="'navy-bg'"/>
          <PosSaleCard :title="'Category Wise Sale'" @cardClick="downloadSale('category_wise_sale')" :icon="'fa fa-money fa-5x'" :color="'lazur-bg'"/>
          <PosSaleCard :title="'Total Void Items'" :is-void-item-card="true" :sale="voidItems ? (voidItems.length) : 0" :icon="'fa fa-trash-o fa-5x'" :color="'yellow-bg'"/>
        </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h2>Void Items </h2>
        </div>
        <div class="ibox-content">
          <table class="table table-striped" v-if="voidItems.length>0">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Item</th>
              <th scope="col">Table/Customer</th>
              <th scope="col">Waiter</th>
              <th scope="col">Reason</th>
              <th scope="col">Created</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(voidItem, index) in voidItems">
              <td><span class="line">{{index+1}}</span></td>
              <td><span class="line">{{voidItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId ? voidItem.menuItemTypesByMenuItemTypeId.menuItemsByMenuItemId.name : 'N/A'}}</span></td>
              <td><span class="line">{{voidItem.tableName}}</span></td>
              <td><span class="line">{{voidItem.waiter ? voidItem.waiter : 'N/A'}}</span></td>
              <td><span class="line">{{voidItem.message}}</span></td>
              <td><span class='m_tip label label-default line'>{{ $moment.parseZone(voidItem.created).local().format('DD/MM/YYYY hh:mm:ss A') }}</span></td>
            </tr>
            </tbody>
          </table>
          <h4 v-else>No void item exists in selected date filter.</h4>
        </div>
      </div>
    </div>
      <div>
        <SaleReceipt :sale="itemWiseSale" :restaurant="restaurantName" :branch="branchName" :item-title="'Item Name'" :start-date="startDate" :end-date="endDate" id="item_wise_sale" :title="'Item Wise Sale'" class="hide" v-if="itemWiseSale"/>
        <SaleReceipt :sale="categoryWiseSale" :restaurant="restaurantName" :branch="branchName"  :item-title="'Category Name'" :start-date="startDate" :end-date="endDate" :title="'Category Wise Sale'" id="category_wise_sale" class="hide" v-if="categoryWiseSale"/>
      </div>
    </div>

  </section>
</template>
<script>
import PageTitle from "@/components/layout_components/PageTitle.vue";
import PosSaleCard from "@/components/Dashboard/PosSaleCard.vue";
import {getCategoryWiseSale, getItemWiseSale, getVoidItems} from "@/api/posDashboard";
import SaleReceipt from "@/components/Dashboard/SaleReceipt.vue";

export default {
  name: "PosDashboard",
  components: {SaleReceipt, PosSaleCard, PageTitle},
  data() {
    return {
      dateOptions: [
        { label: 'today', calculateDates: () => this.calculateDateRange(this.CheckIfCurrentTimeBetween12and4(), this.CheckIfCurrentTimeBetween12and4()) },
        { label: 'yesterday', calculateDates: () => this.calculateDateRange(this.getDateForYesterday(), this.getDateForYesterday()) },
        { label: 'current week', calculateDates: () => this.calculateCurrentWeekDates() },
        { label: 'last week', calculateDates: () => this.calculateLastWeekDates() },
        { label: 'current month', calculateDates: () => this.calculateMonthDates(new Date()) },
        { label: 'last month', calculateDates: () => this.calculateMonthDates(this.getRelativeDate(0, -1)) },
        // { label: 'last 3 months', calculateDates: () => this.calculateLast3MonthDates() },
      ],
      startDate: '',
      endDate: '',
      selectedOption: {
        label : 'Today'
      },
      voidItems: [],
      itemWiseSale: [],
      categoryWiseSale: [],
      changeDate: 0
    };
  },
  computed: {
    totalSale() {
      const totalSaleItem = this.itemWiseSale.find(item => item.totalSale);
      return totalSaleItem && totalSaleItem.totalSale ? totalSaleItem.totalSale.toFixed(2) : 0;
    },
    totalNetSale() {
      const totalSaleItem = this.itemWiseSale.find(item => item.totalNetSale);
      return totalSaleItem && totalSaleItem.totalNetSale ? totalSaleItem.totalNetSale.toFixed(2) : 0;
    },
    restaurantName() {
      return this.$store.state.user && this.$store.state.user.restaurant && this.$store.state.user.restaurant.name
    },
    branchName() {
      return this.$store.state.user.branch && this.$store.state.user.branch.areasByAreaId.name
    },
  },
  watch: {
    changeDate: {
      handler () {
       this.getVoidItems()
       this.getItemWiseSale()
       this.getCategoryWiseSale()
      }
    }
  },
  created() {
    this.calculateDateRange(this.CheckIfCurrentTimeBetween12and4(), this.CheckIfCurrentTimeBetween12and4())
    this.getVoidItems()
    this.getItemWiseSale()
    this.getCategoryWiseSale()
  },
  methods: {
    CheckIfCurrentTimeBetween12and4() {
      let currentDate = new Date();
      const currentHour = moment().hour();
      const closeTimePlusThrushHold = this.getClosingofToday()
      if(closeTimePlusThrushHold <= 12 && currentHour < closeTimePlusThrushHold) {
        currentDate = this.getRelativeDate(0, 0, -1)
      }
      return currentDate
    },

    getDateForYesterday() {
      let currentDate = new Date();
      const currentHour = moment().hour();
      const closeTimePlusThrushHold = this.getClosingofToday()
      console.log('closeTimePlusThrushHold', closeTimePlusThrushHold)
      if(closeTimePlusThrushHold <= 12 &&  currentHour < closeTimePlusThrushHold) {
        currentDate = this.getRelativeDate(0, 0, -2)
      } else {
        currentDate = this.getRelativeDate(0, 0, -1)
      }
      return currentDate
    },

    getClosingofToday() {
      const timings = JSON.parse(this.$store.state.user.branch.timings)
      const currentDay = moment().format('dddd');
      const todayTimings = timings.find(day => day.day === currentDay);
      const currentHour = moment().hours();
      let closingTime = moment(todayTimings.closing, 'HH:mm');
      const yesterday = moment().subtract(1, 'days').format('dddd');
      const yesterdayTiming = timings.find(day => day.day === yesterday);
      const yesterdayHour = moment(yesterdayTiming.closing, 'HH:mm');
      if (currentHour >= 0 && currentHour < 12 && yesterdayHour.hours() < 12 && currentHour < yesterdayHour.hours()+2) {
        closingTime = yesterdayHour
      }
      return closingTime.hour()+2
    },

    downloadSale(id) {
      const WinPrint =window.open('', '', 'left=0,top=0,width=400,height=500px,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(document.getElementById(id).innerHTML) ;
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      window.e = WinPrint;
      console.log('printing');
      setTimeout(()=>{
        WinPrint.close();
      },500)
      console.log('closing')
    },
    async getVoidItems() {
      let params = new URLSearchParams();
      params.append('from', this.startDate)
      params.append('to', this.endDate)
      params.append('branch_id', this.$store.state.user.branch.id)
      let { data } = await getVoidItems(params)
          .catch(ex => {
            this.showErrorMessage(ex)
          });
      this.voidItems = data.body ? data.body : []
    },
    async getItemWiseSale() {
      let params = new URLSearchParams();
      params.append('from', this.startDate)
      params.append('to', this.endDate)
      params.append('branch_id', this.$store.state.user.branch.id)
      let {data} = await getItemWiseSale(params)
          .catch(ex => {
            this.showErrorMessage(ex)
          });
      this.itemWiseSale = data.body
    },
    async getCategoryWiseSale() {
      let params = new URLSearchParams();
      params.append('from', this.startDate)
      params.append('to', this.endDate)
      params.append('branch_id', this.$store.state.user.branch.id)
      let {data} = await getCategoryWiseSale(params)
          .catch(ex => {
            this.showErrorMessage(ex)
          });
      this.categoryWiseSale = data.body
    },
    selectDate(label) {
      const selectedOption = this.dateOptions.find(option => option.label === label);
      selectedOption.calculateDates();
      this.selectedOption = this.capitalizeFirstLetter(selectedOption)
    },
    calculateDateRange(startDate, endDate) {
      this.startDate = this.formatDate(startDate)
      this.endDate = this.formatDate(endDate)
      console.log('Start date:', this.startDate);
      console.log('End date:', this.endDate);
      ++this.changeDate
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    calculateCurrentWeekDates() {
      const today = new Date();
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1));
      const endOfWeek = new Date(today);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // End of the week is 6 days after the start
      this.calculateDateRange(startOfWeek, endOfWeek);
    },
    calculateLastWeekDates() {
      const today = new Date();
      const lastSunday = new Date(today);
      lastSunday.setDate(today.getDate() - today.getDay()); // Move to the previous Sunday

      const startOfLastWeek = new Date(lastSunday);
      startOfLastWeek.setDate(lastSunday.getDate() - 6); // Move to the Monday before last Sunday

      const endOfLastWeek = new Date(lastSunday);

      this.calculateDateRange(startOfLastWeek, endOfLastWeek);
    },
    calculateMonthDates(baseDate) {
      const startOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 1);
      const endOfMonth = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 0);
      this.calculateDateRange(startOfMonth, endOfMonth);
    },
    calculateLast3MonthDates() {
      const today = new Date();
      const startOfLast3Month = new Date(today.getFullYear(), today.getMonth() - 3, 1);
      this.startDate = this.formatDate(startOfLast3Month)
      this.endDate = this.formatDate(today)
      console.log('Start date:', this.startDate);
      console.log('End date:', this.endDate);
      ++this.changeDate
    },
    getRelativeDate(years = 0, months = 0, days = 0) {
      const today = new Date();
      today.setFullYear(today.getFullYear() + years);
      today.setMonth(today.getMonth() + months);
      today.setDate(today.getDate() + days);
      return today;
    },
    capitalizeFirstLetter(string) {
      const label = string.label.charAt(0).toUpperCase() + string.label.slice(1);
      string = {
        label : label
      }
      return  string
    }
  },
}
</script>

<style scoped>
.float-right{
  float: right;
}
.float-left{
  float: left;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.table-striped thead th,
.table-striped tbody td {
  text-align: center; /* Center align text in cells */
  padding: 8px; /* Adjust the padding value based on your preference */
}
.hide {
  display: none;
}
.width-18 {
  width: 18rem;
}
</style>